let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3ZLVG"), load("jgEe0"), load("01FTB")]).then(() => parcelRequire('bZhvE'));